shadow$provide[347] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Screen:{enumerable:true, get:function() {
  return Screen;
}}});
var require$three = require("three");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
var require$_DOT__DOT__SLASH_geometry_SLASH_screengeometry_DOT_js = require("../geometry/screengeometry.js");
class Screen extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    let f;
    super(renderer, shaders, options);
    let {uniforms} = options;
    const {map, combine, stpq, linear} = options;
    if (uniforms == null) {
      uniforms = {};
    }
    const hasStyle = uniforms.styleColor != null;
    this.geometry = new require$_DOT__DOT__SLASH_geometry_SLASH_screengeometry_DOT_js.ScreenGeometry({width:options.width, height:options.height,});
    this._adopt(uniforms);
    this._adopt(this.geometry.uniforms);
    const factory = shaders.material();
    const v = factory.vertex;
    v.pipe("raw.position.scale", this.uniforms);
    v.fan();
    v.pipe("stpq.xyzw.2d", this.uniforms);
    v.next();
    v.pipe("screen.position", this.uniforms);
    v.join();
    factory.fragment = f = this._fragmentColor(hasStyle, false, null, null, map, 2, stpq, combine, linear);
    f.pipe("fragment.color", this.uniforms);
    const opts = factory.link({side:require$three.DoubleSide,});
    this.material = this._material(opts);
    const object = new require$three.Mesh(this.geometry, this.material);
    object.frustumCulled = false;
    object.userData = opts;
    this._raw(object);
    this.renders = [object];
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.renders = this.geometry = this.material = null;
    return super.dispose();
  }
}

};